var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#55ACEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1497 16.3338C27.1612 16.4937 27.1612 16.6536 27.1612 16.8135C27.1612 21.6904 23.4493 27.3097 16.665 27.3097C14.5749 27.3097 12.6333 26.7043 11 25.6536C11.297 25.6879 11.5825 25.6993 11.8909 25.6993C13.6154 25.6993 15.203 25.1168 16.4708 24.1232C14.849 24.0889 13.4898 23.0267 13.0216 21.5648C13.25 21.599 13.4784 21.6219 13.7183 21.6219C14.0495 21.6219 14.3807 21.5762 14.6891 21.4963C12.9987 21.1536 11.7309 19.6688 11.7309 17.8757V17.83C12.222 18.1041 12.7931 18.2755 13.3984 18.2983C12.4048 17.6358 11.7538 16.5051 11.7538 15.2259C11.7538 14.5407 11.9365 13.9125 12.2563 13.3643C14.0723 15.6028 16.802 17.0647 19.8629 17.2247C19.8058 16.9506 19.7715 16.6651 19.7715 16.3795C19.7715 14.3465 21.4162 12.6904 23.4606 12.6904C24.5228 12.6904 25.4822 13.1359 26.156 13.8554C26.9898 13.6955 27.7893 13.3871 28.4974 12.9645C28.2233 13.8212 27.6408 14.5407 26.8756 14.9975C27.618 14.9176 28.3375 14.712 28.9999 14.4265C28.4975 15.1574 27.8693 15.8084 27.1497 16.3338Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwIcon);
export default __webpack_public_path__ + "static/media/twIcon.d132910e313b84a6ef4c35131702d2d8.svg";
export { ForwardRef as ReactComponent };